import { useI18n } from "vue-i18n";
import { useToastStore } from "@/components/TToasts/toast.store.ts";

export function useCopyToClipboard() {
  const { t } = useI18n();
  const toastStore = useToastStore();

  const copy = async (value: string): Promise<void> => {
    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);
      toastStore.displayToast({
        title: t("copied"),
        message: t("copied-to-clipboard"),
        duration: 2000,
        variant: "success",
        testId: "copy-to-clipboard-toast-success",
      });
    } catch {
      toastStore.displayToast({
        title: t("error"),
        message: t("generic-error"),
        duration: 2000,
        variant: "danger",
        testId: "copy-to-clipboard-toast-error",
      });
    }
  };

  return { copy };
}
